/** Lokasjonskategori Varemottak (ST42). */
export const RECEIPT_BIN_CATEGORY = 2;

/** Tåler både boolean og string/tall fra inline-editorer. */
const isTrue = (value: unknown): boolean =>
  value === true || value === 'true' || value === 1 || value === '1';

export interface ReceiptBinFlags {
  stcBinCatNo?: unknown;
  pickableYesNo?: unknown;
  reservationAllowed?: unknown;
}

/**
 * Mottakslokasjon (StcBinCatNo = 2) som samtidig er plukkbar eller reserverbar (TW 36401238).
 * Mottak er et mellomlager: saldoen utelates bevisst fra telleresultatet til ERP, så plukk og
 * reservasjon herfra gir feil ERP-saldo etter telling og påvirker påfyllingsgenereringen.
 * Brukes til advarsel før lagring — ikke sperre.
 */
export const isReceiptBinPickConflict = (bin: ReceiptBinFlags): boolean =>
  Number(bin.stcBinCatNo) === RECEIPT_BIN_CATEGORY &&
  (isTrue(bin.pickableYesNo) || isTrue(bin.reservationAllowed));
